export default __webpack_public_path__ + "media/icons/icon-lock-2e403ecb.svg";